import { useEffect } from 'react';
import { useStore } from '@/store';
import { GALAXY_COLOR, ACX_COLOR, BONA_COLOR } from '@/constant';
import { ClientHostType } from '@/types';
function setCSSVariable(propertyName, value) {
  document.documentElement.style.setProperty(propertyName, value);
}

const themeMap = {
  [ClientHostType.acx]: ACX_COLOR,
  [ClientHostType.galaxy]: GALAXY_COLOR,
  [ClientHostType.icirena]: BONA_COLOR,
};

// 根据租户设置主题色
const useTheme = () => {
  const { channel } = useStore();
  useEffect(() => {
    let colors = themeMap[channel];
    for (const key in colors) {
      setCSSVariable(key, colors[key]);
    }
  }, [channel]);
};

export default useTheme;
